/* eslint-disable max-len */
module.exports = {
  // ================ HOME-PAGE ================
  homepage: {
    sections: [
      {
        href: "/services/ndt",
        linktext: "Non-destructive laboratory (NDT)",
        images: [
          "/img/homepage/ut-01.jpg", "/img/homepage/ut-02.jpg", "/img/homepage/ut-03.jpg", "/img/homepage/ut-04.jpg", "/img/homepage/rk-01.jpg", "/img/homepage/rk-02.jpg",
          "/img/homepage/dpi-01.jpg", "/img/homepage/dpi-02.jpg", "/img/homepage/vac-01.jpg", "/img/homepage/bridge-01.jpg",
          "/img/homepage/bridge-02.jpg", "/img/homepage/bridge-03.jpg", "/img/homepage/pmi-01.jpg",
          "/img/homepage/vmc-01.jpg", "/img/homepage/vmc-02.jpg", "/img/homepage/thermo-01.jpg", "/img/homepage/mpd-01.jpg"
        ]
      },
      {
        href: "/services/mex",
        linktext: "Mechanical testing laboratory of welds, steels and alloys",
        images: [
          "/img/homepage/bend-01.jpg", "/img/homepage/hrdn-01.jpg", "/img/homepage/kcv-01.jpg", "/img/homepage/kcv-02.jpg", "/img/homepage/mgr-01.jpg",
          "/img/homepage/tens-01.jpg", "/img/homepage/templates-01.jpg"
        ]
      },
      {
        href: "/services/geodesy",
        linktext: "Geodesy, Surveying, Topography",
        images: [
          "/img/homepage/geodesy-01.jpg", "/img/homepage/geodesy-02.jpg", "/img/homepage/geodesy-03.jpg", "/img/homepage/geodesy-04.jpg", "/img/homepage/geodesy-05.jpg"
        ]
      },
      {
        href: "/services/stroylab",
        linktext: "Civil Laboratory (concrete, sand, crushed stone, ground, asphalt, plastics, waterproofing, heat insulation material...)",
        images: [
          "/img/homepage/concrete-01.jpg", "/img/homepage/concrete-02.png", "/img/homepage/concrete-03.jpg", "/img/homepage/concrete-04.jpg", "/img/homepage/concrete-05.jpg", "/img/homepage/asphalt-01.jpg",
          "/img/homepage/soil-01.jpg", "/img/homepage/breakstone-02.jpg", "/img/homepage/breakstone-03.jpg", "/img/homepage/soil-02.jpg", "/img/homepage/soil-03.jpg", "/img/homepage/waterproofing-01.jpg",
          "/img/homepage/scales-01.jpg", "/img/homepage/breakstone-01.jpg"
        ]
      }

    ]
  }
};
/* eslint-enable max-len */
